import MediaPanel from './MediaPanel';

export default MediaPanel;
